import { getTopicOptions } from "../../services/dashboard";

/**
 *
 * @param {string} language Language "en" or "es"
 * @param {function} setSubtopicOptions Setter function for subtopics.
 *
 * @returns Object with response from API
 */
export async function getSubtopicData(language, setSubtopicOptions) {
  try {
    const responseTopics = await getTopicOptions(false, language);

    if (responseTopics === "ERROR_LOADING_DATA") return "ERROR_LOADING_DATA";

    const { data } = responseTopics;

    if (data) {
      if (setSubtopicOptions) setSubtopicOptions(data);

      return data;
    }
  } catch (error) {
    console.log("Error getting topic data");
  }
}
